<!--
 * @Author: sipeng
 * @LastEditTime: 2022-09-14 14:18:00
 * @Description: 门禁报警
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="h-100">
    <el-table
      border
      v-loading="accessControlLoading"
      height="100%"
      ref="singleTable"
      :data="tableData"
      class="w-100"
    >
      <el-table-column align="center" type="index" label="序号" width="50"> </el-table-column>
      <el-table-column align="center" property="regionld" label="事件发生区域"> </el-table-column>
      <el-table-column align="center" property="srcName" label="事件源名称"> </el-table-column>
      <el-table-column align="center" property="status" label="事件状态"> </el-table-column>
      <el-table-column align="center" property="startTime" label="开始时间"> </el-table-column>
      <el-table-column align="center" property="endTime" label="结束时间"> </el-table-column>
    </el-table>
    <el-pagination
      class="m-t-5 r"
      @current-change="currentChange"
      @size-change="handleSizeChange"
      :current-page.sync="page.currentPage"
      :page-sizes="$pageSizeAll"
      layout="sizes, prev, pager, next"
      :total="page.total"
      background
    ></el-pagination>
  </div>
</template>
<script>
import LocalSense from '@/services/baoChang/localSense'

export default {
  data() {
    return {
      accessControlLoading: false,
      page: {
        size: 15,
        total: null,
        currentPage: 1,
      },
      tableData: [],
    }
  },
  methods: {
    // 获取门禁报警列表
    async getAccessControlList() {
      this.accessControlLoading = true
      const payload = {
        pageNo: this.page.currentPage,
        pageSize: this.page.size,
      }
      const res = await LocalSense.getAlarm(payload)
      this.accessControlLoading = false
      console.log(res, '----------------------------==========')
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data.data.list
        this.page.total = res.data.data.total
      }
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
      this.getAccessControlList()
    },
    handleSizeChange(size) {
      this.page.size = size
      this.getAccessControlList()
    },
  },
  created() {
    this.getAccessControlList()
  },
}
</script>
